import React from 'react';
import { IconInfoOutline } from '@carnica/graphics';
import { Button, Checkbox, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { ConnectionBlockActionCreator } from "../../../../../store/actions";
import { Metric } from "../../../../../../../../utils/metric";
import styles from "../styles.pcss";
var cn = classNames.bind(styles);
export var _BalanceItem = function _BalanceItem(_ref) {
  var checked = _ref.checked,
    description = _ref.description,
    label = _ref.label,
    _ref$shortDesc = _ref.shortDesc,
    shortDesc = _ref$shortDesc === void 0 ? '' : _ref$shortDesc,
    setBonusBalanceDescription = _ref.setBonusBalanceDescription,
    setMainBalance = _ref.setMainBalance,
    setOpenedModal = _ref.setOpenedModal,
    balanceType = _ref.balanceType,
    _ref$balanceCode = _ref.balanceCode,
    balanceCode = _ref$balanceCode === void 0 ? '' : _ref$balanceCode,
    balanceName = _ref.balanceName,
    userType = _ref.userType;
  var handleIconClick = function handleIconClick(e) {
    e.stopPropagation();
    if (shortDesc) {
      setBonusBalanceDescription(shortDesc);
      setOpenedModal('BonusBalanceModal');
    }
  };
  var handleBalanceChange = function handleBalanceChange() {
    setOpenedModal(null);
    setMainBalance({
      balanceType: balanceType,
      balanceCode: balanceCode
    });
  };
  return /*#__PURE__*/React.createElement(Metric, {
    data: JSON.stringify({
      balanceName: balanceName,
      userType: userType
    }),
    events: {
      fubMetricSideMenu: ['handleBalanceChangeClick']
    },
    mode: "click",
    "data-t-id": "BalancesSelect-BalanceItem"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('option'),
    mode: "inline",
    onClick: handleBalanceChange,
    "data-t-id": "BalancesSelect-BalanceItem"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('text-wrapper'),
    "data-t-id": "BalancesSelect-BalanceItem"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('label-wrapper')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    rows: 3,
    truncate: true,
    variant: "body-medium"
  }, label), shortDesc ? /*#__PURE__*/React.createElement(IconInfoOutline, {
    onClick: handleIconClick
  }) : null), /*#__PURE__*/React.createElement(Text, {
    color: "tertiary",
    rows: 2,
    truncate: true,
    variant: "body-small"
  }, description)), /*#__PURE__*/React.createElement(Checkbox, {
    checked: checked,
    className: cn('checkbox')
  })));
};
var mapDispatchToProps = {
  setBonusBalanceDescription: ConnectionBlockActionCreator.setBonusBalanceDescription,
  setMainBalance: ConnectionBlockActionCreator.setMainBalance,
  setOpenedModal: ConnectionBlockActionCreator.setOpenedModal
};
var connector = connect(null, mapDispatchToProps);
export var BalanceItem = connector(_BalanceItem);